



































































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat, isDecimal } from '@/utils/common'
import { MensagensDaApiEnum } from '@/types/_'

@Component

export default class ComponentModalCriarEditarSenioridade extends Vue {
  @Prop({ required: true, default: 'CREATE' }) mode: string

  $refs!: { formItemSenioridade: any }

  formItemSenioridadeRules: any = {
    valid: true,
    nome: [(v: string) => !!v || 'Campo obrigatório'],
    codigoPontuacao: [(v: string) => !!v || 'Campo obrigatório'],
    percentual: [
      (v: any) => this.validatePercentualObrigatorio(v),
      (v: string) => this.validatePercentual(v),
    ],
  }

  /** isDecimal considera vazio como válido (+'' === 0), então a obrigatoriedade precisa de regra própria. */
  validatePercentualObrigatorio(value: any) {
    if (value === '' || value === null || value === undefined) return 'Campo obrigatório'
    return true
  }

  validatePercentual(value: string) {
    if (isDecimal(value)) return 'Formato inválido.'
    return true
  }

  dicaPercentual: string = 'Use somente números inteiros ou decimais separados por ponto (.)'

  loadCreateOrUpdateItemSenioridade: boolean = false
  get loadingCreateOrUpdateItemSenioridade() { return this.loadCreateOrUpdateItemSenioridade }
  set loadingCreateOrUpdateItemSenioridade(value: boolean) { this.loadCreateOrUpdateItemSenioridade = value }

  get modalCriarEditarItemSenioridade() { return this.getFinanceiroStore.modal.criarEditarItemSenioridade }
  set modalCriarEditarItemSenioridade(value: boolean) { this.getFinanceiroStore.setModal({ name: 'criarEditarItemSenioridade', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  async createOrUpdateItemSenioridade() {
    this.loadingCreateOrUpdateItemSenioridade = true

    if (this.$refs.formItemSenioridade.validate()) {
      const request = this.mode === 'CREATE'
        ? await this.getFinanceiroStore.createItemsSenioridade()
        : await this.getFinanceiroStore.updateItemsSenioridade()

      if (request.success) {
        if (request.message === MensagensDaApiEnum.UNCHANGED_PAYLOAD && this.mode === 'EDIT') {
          EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma alteração foi realizada', icon: 'info', color: '#2196F3' })
          this.modalCriarEditarItemSenioridade = false
          this.loadingCreateOrUpdateItemSenioridade = false
          return
        }

        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Item de pontuação ${this.mode === 'CREATE' ? 'criado' : 'atualizado'} com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.$emit('update-items-table', true)
        this.modalCriarEditarItemSenioridade = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingCreateOrUpdateItemSenioridade = false
  }

  onlyFloatUtil(value) {
    return onlyFloat(value)
  }

  @Watch('modalCriarEditarItemSenioridade')
  onChangeModalCriarEditarItemSenioridade(value) {
    if (!value) {
      this.getFinanceiroStore.clearItemSenioridade()
      this.getFinanceiroStore.clearOriginalItemSenioridade()
      this.$refs.formItemSenioridade.resetValidation()
    }
  }
}
